import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Member from "./component/team/Member";

import "../../assets/Common.css";

function Team(props) {
  const { user, plan, team, member, leader } = props;
  const [buttonState, setButtonState] = useState(0);
  const [errorState, setErrorState] = useState(null);
  const [email, setEmail] = useState("");
  const { i18n } = useTranslation();
  const [resultMembers, setResultMembers] = useState([]);
  // const [ selectedProject, setSelectedProject ] = useState(null);
  // const [ currentProject, setCurrentProject ] = useState(null);

  useEffect(() => {
    if (member !== null && member !== undefined) {
      let initialResults = [];
      member.forEach((employee) => {
        initialResults.push(employee);
      });
      setResultMembers(initialResults);
    }
  }, [user, plan, member, team, leader]);

  function updateState(state = null) {
    if (resultMembers.length >= 3) {
      return;
    }
    if (state === null) {
      let tmpButtonState = buttonState + 1;
      if (tmpButtonState === 3) {
        tmpButtonState = 0;
        setEmail("");
      }
      setButtonState(tmpButtonState);
    } else {
      setButtonState(state);
    }
  }

  function inviteMember() {
    let token = localStorage.getItem("token");
    if (!token) {
      localStorage.removeItem("token");
      localStorage.removeItem("tokenExpiration");
      window.location = process.env.REACT_APP_URL + "/users/sign_in";
      return;
    }
    const config = {
      headers: { Authorization: `${token}` },
    };
    let data = {
      email: email,
      role: "member",
      language: localStorage.getItem("i18nextLng"),
      invitation: "team",
    };
    if (email === "" || undefined) {
      updateState(1);
      setErrorState("Remplissez le champs email");
      return;
    }
    setErrorState(null);
    axios
      .post(process.env.REACT_APP_URL_API + "/invitation", data, config, {
        validateStatus: function (status) {
          return status >= 200 && status < 500; // Catch errors from 200 to 499
        },
      })
      .then((res) => {
        if (res.data !== null) {
          if (res.status === 201) {
            setResultMembers((prevResults) => [
              ...prevResults,
              { user: res.data["user"], invitation_accepted: false },
            ]);
          }
        }
      })
      .catch((res) => {
        if (res.response.status === 500) {
          setErrorState(res.response.data.error);
          updateState(1);
          return;
        }
        if (res.response.status === 422) {
          setErrorState(i18n.t(`team.error_${res.response.data.error}`));
          updateState(1);
          return;
        }
        if (
          res.response.data === "Signature has expired" ||
          res.response.data === "No verification key available"
        ) {
          localStorage.removeItem("token");
          localStorage.removeItem("tokenExpiration");
          window.location = process.env.REACT_APP_URL + "/users/sign_in";
          return;
        }
        if (res.response.status === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("tokenExpiration");
          window.location = process.env.REACT_APP_URL + "/users/sign_in";
          return;
        }
      });
  }

  return (
    user && (
      <div className="flex flex-col w-full gap-y-10">
        {resultMembers && resultMembers.length <= 2 && (
          <div>
            {buttonState === 0 && (
              <button
                className="flex flex-row gap-x-4 bg-white text-secondary btn border border-gray-custom-input"
                onClick={() => {
                  updateState();
                }}
              >
                <svg
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 11.9416C8.73022 11.9416 8.51162 11.723 8.51162 11.4533V9.98817H7.04649C6.77671 9.98817 6.55812 9.76958 6.55812 9.4998C6.55812 9.23003 6.77671 9.01144 7.04649 9.01144H8.51162V7.54635C8.51162 7.27658 8.73022 7.05799 9 7.05799C9.26978 7.05799 9.48838 7.27658 9.48838 7.54635V9.01144H10.9535C11.2233 9.01144 11.4419 9.23003 11.4419 9.4998C11.4419 9.76958 11.2233 9.98817 10.9535 9.98817H9.48838V11.4533C9.48838 11.723 9.26978 11.9416 9 11.9416Z"
                    fill="#486497"
                  />
                  <path
                    d="M9 16.4998C7.42176 16.4998 6.28131 16.4998 5.36238 16.3762C4.32956 16.2373 3.63079 15.9372 3.0965 15.4031C2.56241 14.8691 2.26236 14.1703 2.12346 13.1375C2 12.2184 2 11.0782 2 9.4998C2 7.92142 2 6.78138 2.12366 5.86228C2.26255 4.82949 2.56261 4.13074 3.0967 3.59647C3.63079 3.0622 4.32956 2.76235 5.36238 2.62365C6.2815 2.5 7.42176 2.5 9 2.5C10.5782 2.5 11.7187 2.5 12.6376 2.62365C13.6704 2.76254 14.3692 3.06259 14.9033 3.59667C15.6869 4.3802 15.8937 5.47218 15.9635 6.87104C15.9769 7.14043 15.7695 7.36976 15.4999 7.38304C15.2309 7.39691 15.0012 7.18907 14.9879 6.91969C14.917 5.49503 14.7068 4.78163 14.2125 4.28741C13.402 3.47692 11.9308 3.47692 8.9998 3.47692C6.06876 3.47692 4.59758 3.47692 3.78707 4.28741C2.97656 5.0979 2.97656 6.56904 2.97656 9.5C2.97656 12.431 2.97656 13.9021 3.78707 14.7126C4.59758 15.5233 6.06876 15.5233 8.9998 15.5233C11.9308 15.5233 13.402 15.5233 14.2125 14.7128C15.0232 13.9023 15.0232 12.4312 15.0232 9.5002C15.0232 9.23042 15.2418 9.01183 15.5116 9.01183C15.7814 9.01183 16 9.23042 16 9.5002C16 11.0784 16 12.2188 15.8763 13.1377C15.7374 14.1705 15.4374 14.8693 14.9033 15.4033C14.3692 15.9374 13.6704 16.2377 12.6376 16.3763C11.7187 16.5 10.5782 16.5 9 16.5V16.4998Z"
                    fill="#486497"
                  />
                </svg>
                <p>{`inviter un membre (${
                  resultMembers && resultMembers.length
                }/3)`}</p>
              </button>
            )}
            {buttonState === 1 && (
              <div className="flex flex-col gap-y-1">
                <form
                  className="flex flex-row gap-x-4 "
                  onSubmit={() => {
                    updateState();
                    inviteMember();
                  }}
                >
                  <input
                    tabIndex={-1}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    id="email"
                    name="email"
                    className={`input rounded-custom-input border border-gray-custom-input text-primary font-normal input-team-add ${
                      errorState === null ? "" : "border-error"
                    }`}
                    placeholder="adresse e-mail du membre de l’équipe"
                  ></input>
                  <button className="bg-secondary rounded-custom-input text-white btn p-3.5">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.39241 4.78506C6.39241 4.47681 6.6423 4.22692 6.95055 4.22692H10.1059C10.4141 4.22692 10.664 4.47681 10.664 4.78506V7.94783C10.664 8.25609 10.4141 8.50597 10.1059 8.50597C9.79765 8.50597 9.54776 8.25609 9.54776 7.94783V5.3432H6.95055C6.6423 5.3432 6.39241 5.09332 6.39241 4.78506Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.37278 1.37278C2.36587 0.379685 3.85193 0 5.76744 0H10.2326C12.1481 0 13.6341 0.379685 14.6272 1.37278C15.6203 2.36587 16 3.85193 16 5.76744V10.2326C16 12.1481 15.6203 13.6341 14.6272 14.6272C13.6341 15.6203 12.1481 16 10.2326 16H5.76744C3.85193 16 2.36587 15.6203 1.37278 14.6272C0.379685 13.6341 0 12.1481 0 10.2326V5.76744C0 3.85193 0.379685 2.36587 1.37278 1.37278ZM2.16211 2.16211C1.48078 2.84343 1.11628 3.96203 1.11628 5.76744V10.2326C1.11628 12.038 1.48078 13.1566 2.16211 13.8379C2.84343 14.5192 3.96203 14.8837 5.76744 14.8837H10.2326C12.038 14.8837 13.1566 14.5192 13.8379 13.8379C14.5192 13.1566 14.8837 12.038 14.8837 10.2326V5.76744C14.8837 3.96203 14.5192 2.84343 13.8379 2.16211C13.1566 1.48078 12.038 1.11628 10.2326 1.11628H5.76744C3.96203 1.11628 2.84343 1.48078 2.16211 2.16211Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.5006 4.3904C10.7186 4.60837 10.7186 4.96176 10.5006 5.17973L6.28856 9.3918C6.07059 9.60977 5.7172 9.60977 5.49923 9.3918C5.28126 9.17383 5.28126 8.82044 5.49923 8.60247L9.71131 4.3904C9.92928 4.17243 10.2827 4.17243 10.5006 4.3904Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3.00552 11.1794C3.10323 10.887 3.41943 10.7292 3.71179 10.8269C6.49186 11.756 9.50814 11.756 12.2882 10.8269C12.5806 10.7292 12.8968 10.887 12.9945 11.1794C13.0922 11.4717 12.9344 11.7879 12.642 11.8856C9.63232 12.8915 6.36768 12.8915 3.35798 11.8856C3.06562 11.7879 2.90782 11.4717 3.00552 11.1794Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </form>
                <span className="text-error">{errorState}</span>
              </div>
            )}
            {buttonState === 2 && (
              <div className="flex flex-row gap-x-2">
                <div className="flex flex-row gap-x-1 label text-secondary my-auto text-md">
                  <svg
                    width="15"
                    height="18"
                    viewBox="0 0 15 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.6743 1.232C10.6036 1.28046 10.3354 1.58276 10.5512 2.47004C10.7347 3.22427 10.858 3.72679 10.9353 4.04052C10.971 4.18526 10.9969 4.2898 11.0145 4.36031C11.1212 4.49856 11.227 4.63769 11.3315 4.77718C11.6239 5.16726 11.9079 5.5622 12.1745 5.95049C12.122 5.70386 12.0678 5.45632 12.0124 5.21042C11.8207 4.35919 11.6171 3.53763 11.4242 2.85345C11.2275 2.15566 11.0529 1.64091 10.9245 1.377C10.8646 1.25384 10.7989 1.22077 10.7723 1.21237C10.7463 1.20414 10.7147 1.20432 10.6743 1.232ZM13.962 9.31643C13.8303 8.20797 13.5133 6.51976 13.1572 4.93814C12.9622 4.07235 12.7532 3.22849 12.5528 2.5174C12.3562 1.81991 12.1567 1.20952 11.9755 0.836982C11.7906 0.456986 11.4891 0.175563 11.1179 0.0581786C10.7461 -0.0593836 10.3493 0.00332921 10.0226 0.227228C9.44279 0.624461 9.20058 1.40396 9.33112 2.34496C9.28064 2.2898 9.23043 2.23547 9.18055 2.18203C8.50561 1.45908 7.83277 0.837361 7.30652 0.566938C6.59847 0.203088 5.76816 0.350736 5.33228 1.02414C4.90686 1.6814 5.01552 2.58709 5.57516 3.45357C5.83553 3.85671 6.30042 4.40896 6.76711 4.96335C6.88997 5.10929 7.01294 5.25537 7.13235 5.39893C7.13299 5.3997 7.13363 5.40047 7.13427 5.40125C7.11735 5.39449 7.10044 5.3878 7.08357 5.38118C6.57796 5.18299 6.04986 5.03166 5.57506 5.03166C5.06593 5.03166 4.45521 5.25963 3.8912 5.5502C3.30646 5.85145 2.69081 6.26278 2.15066 6.7147C1.61633 7.16174 1.12297 7.67588 0.814258 8.19254C0.524733 8.6771 0.28191 9.37544 0.684249 9.99568C0.753721 10.1028 0.830872 10.2 0.915872 10.286C0.825536 10.3399 0.74013 10.3999 0.660454 10.4654C0.128183 10.9027 -0.218024 11.6736 0.158015 12.4466C0.410096 12.9648 0.846437 13.5419 1.36172 14.1422C1.88367 14.7504 2.51994 15.42 3.19975 16.124C3.86233 16.8102 4.80821 17.5104 6.00929 17.8268C7.22378 18.1468 8.65449 18.0619 10.244 17.2451C11.8181 16.4362 12.7843 15.3951 13.3375 14.0833C13.8784 12.8005 14 11.3123 14 9.66076C14 9.54979 13.986 9.4341 13.962 9.31643ZM12.8026 9.52168C12.8105 9.59099 12.8176 9.65745 12.8237 9.72083L12.825 9.7207C12.8219 11.3112 12.6943 12.5717 12.2594 13.6031C11.8312 14.6185 11.0819 15.4644 9.71852 16.165C8.37055 16.8577 7.22931 16.9016 6.30106 16.6571C5.35941 16.409 4.59177 15.8513 4.03374 15.2734C3.35368 14.5691 2.73951 13.9221 2.24289 13.3434C1.7396 12.757 1.38925 12.2772 1.20897 11.9066C1.15264 11.7908 1.15537 11.6048 1.39418 11.4086C1.62692 11.2173 2.02021 11.1011 2.46209 11.2433C2.60912 11.2906 2.7675 11.3952 2.95738 11.5807C3.13356 11.7528 3.30331 11.9596 3.50418 12.2044C3.52397 12.2285 3.54406 12.253 3.5645 12.2779C3.98758 12.7925 4.55347 13.4752 5.39269 13.7569C6.31234 14.0655 7.14161 13.6954 7.69679 13.1599C8.23664 12.6391 8.61465 11.8747 8.61465 11.1702C8.61465 10.4497 8.22188 9.74626 7.7136 9.21513C7.1944 8.67257 6.47996 8.22801 5.69255 8.06283C5.15918 7.95094 4.62617 8.15731 4.2122 8.36469C3.92488 8.50863 3.61141 8.6996 3.32532 8.87389C3.19541 8.95304 3.07114 9.02874 2.95753 9.09505C2.54864 9.33367 2.24393 9.47343 2.01683 9.50226C1.91718 9.51491 1.85957 9.50191 1.82331 9.48573C1.78944 9.47061 1.73226 9.4343 1.66189 9.32583L1.66171 9.32555C1.6559 9.3166 1.64143 9.29431 1.65212 9.2201C1.66462 9.13335 1.70996 9.00114 1.81552 8.82447C2.02726 8.4701 2.4093 8.05544 2.89245 7.65121C3.36978 7.25186 3.9137 6.88943 4.41775 6.62975C4.94253 6.35939 5.34982 6.23925 5.57506 6.23925C5.83462 6.23925 6.20294 6.32843 6.66485 6.50949C7.11648 6.68653 7.61185 6.93274 8.11157 7.20496C8.61019 7.47658 9.10087 7.76727 9.5459 8.0314L9.5858 8.05509C10.0076 8.30546 10.3995 8.53808 10.6977 8.69132L11.2231 7.61122C10.9571 7.47449 10.5905 7.25693 10.144 6.99189L10.1335 6.98567C9.91945 6.85862 9.69019 6.72264 9.45173 6.58407C9.13498 5.97385 8.55495 5.25083 8.02547 4.61425C7.88599 4.44656 7.74917 4.28386 7.6177 4.12754C7.16094 3.58443 6.76881 3.11816 6.55411 2.78572C6.1388 2.14271 6.24747 1.79049 6.31057 1.693C6.36322 1.61166 6.50995 1.50773 6.78105 1.64704C7.10545 1.81374 7.65402 2.29112 8.33271 3.0181C8.99193 3.72421 9.72106 4.60738 10.4007 5.51413C11.0809 6.42159 11.7028 7.34101 12.1513 8.11835C12.376 8.50767 12.5512 8.8511 12.6684 9.13298C12.7396 9.30416 12.7805 9.43213 12.8026 9.52168ZM3.26147 10.3008C3.45139 10.4187 3.61855 10.5605 3.76684 10.7054C3.99313 10.9264 4.20594 11.1861 4.39811 11.4206C4.41969 11.4469 4.44101 11.4729 4.46206 11.4985C4.91157 12.0454 5.2803 12.4488 5.75742 12.6089C6.15415 12.7421 6.55093 12.609 6.8927 12.2793C7.2498 11.9349 7.43966 11.4721 7.43966 11.1702C7.43966 10.8844 7.26457 10.4681 6.87589 10.0619C6.49814 9.66716 5.98653 9.35699 5.45757 9.24603C5.33277 9.21985 5.10884 9.25892 4.72702 9.4502C4.48167 9.57311 4.24325 9.71867 3.98314 9.87746C3.84251 9.96332 3.69554 10.053 3.53771 10.1452C3.4493 10.1967 3.35692 10.2494 3.26147 10.3008Z"
                      fill="#486497"
                    />
                  </svg>
                  <span>{`e-mail d’invitation envoyé`}</span>
                </div>
                <button
                  className="bg-secondary border rounded text-white btn"
                  onClick={() => {
                    updateState();
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 10.616C7.71095 10.616 7.47674 10.3818 7.47674 10.0928V8.52304H5.90696C5.61791 8.52304 5.3837 8.28883 5.3837 7.99979C5.3837 7.71075 5.61791 7.47654 5.90696 7.47654H7.47674V5.90681C7.47674 5.61776 7.71095 5.38356 8 5.38356C8.28905 5.38356 8.52326 5.61776 8.52326 5.90681V7.47654H10.093C10.3821 7.47654 10.6163 7.71075 10.6163 7.99979C10.6163 8.28883 10.3821 8.52304 10.093 8.52304H8.52326V10.0928C8.52326 10.3818 8.28905 10.616 8 10.616Z"
                      fill="white"
                    />
                    <path
                      d="M8 15.4998C6.30903 15.4998 5.08711 15.4998 4.10255 15.3673C2.99595 15.2185 2.24727 14.897 1.67482 14.3248C1.10259 13.7526 0.781096 13.0039 0.63228 11.8973C0.5 10.9126 0.5 9.69092 0.5 7.99979C0.5 6.30866 0.5 5.08719 0.63249 4.10244C0.781305 2.99588 1.1028 2.24722 1.67503 1.67479C2.24727 1.10236 2.99595 0.781088 4.10255 0.632486C5.08732 0.5 6.30903 0.5 8 0.5C9.69097 0.5 10.9129 0.5 11.8975 0.632486C13.004 0.781297 13.7527 1.10278 14.325 1.675C15.1645 2.5145 15.3861 3.68448 15.4609 5.18326C15.4753 5.47188 15.253 5.7176 14.9642 5.73183C14.676 5.74669 14.4298 5.524 14.4156 5.23538C14.3396 3.70896 14.1144 2.94461 13.5849 2.41508C12.7165 1.5467 11.1402 1.5467 7.99979 1.5467C4.85939 1.5467 3.28312 1.5467 2.41472 2.41508C1.54631 3.28346 1.54631 4.85969 1.54631 8C1.54631 11.1403 1.54631 12.7165 2.41472 13.5849C3.28312 14.4535 4.85939 14.4535 7.99979 14.4535C11.1402 14.4535 12.7165 14.4535 13.5849 13.5851C14.4535 12.7167 14.4535 11.1405 14.4535 8.00021C14.4535 7.71117 14.6877 7.47696 14.9767 7.47696C15.2658 7.47696 15.5 7.71117 15.5 8.00021C15.5 9.69113 15.5 10.913 15.3675 11.8976C15.2187 13.0041 14.8972 13.7528 14.325 14.325C13.7527 14.8972 13.004 15.2189 11.8975 15.3675C10.9129 15.5 9.69097 15.5 8 15.5V15.4998Z"
                      fill="white"
                    />
                  </svg>
                </button>
              </div>
            )}
          </div>
        )}
        <div className="flex flex-col w-full gap-y-2">
          {resultMembers.map((result, index) => (
            <div key={index}>
              <Member
                id={result && result.user.id}
                invitation={result.invitation_accepted}
                avatar={result.avatar}
                plan={plan}
                setMember={setResultMembers}
                member={resultMembers}
                updateState={updateState}
              ></Member>
            </div>
          ))}
        </div>
      </div>
    )
  );
}

export default Team;
